module.exports = __webpack_public_path__ + "static/media/footer vector.e3a89712.svg";